<!-- Market config decides: no profile, no social proof (e.g. NL). -->
@if (profile(); as tp) {
  <div class="trustpilot_container">
    <!-- TrustBox widget - Carousel -->
    <div
      #trustpilotWidget
      class="trustpilot-widget"
      [attr.data-locale]="locale()"
      data-template-id="53aa8912dec7e10d38f59f36"
      [attr.data-businessunit-id]="tp.businessUnitId"
      data-style-height="140px"
      data-style-width="100%"
      data-stars="4,5"
      [attr.data-review-languages]="tp.reviewLanguage"
    >
      <a [href]="tp.reviewUrl" target="_blank" rel="noopener">Trustpilot</a>
    </div>
    <!-- End TrustBox widget -->
  </div>
}
